import { Tooltip } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import BadgeType from '../BadgeType';

Badges.propTypes = {
	badges: PropTypes.array,
	commentId: PropTypes.number,
};

export default function Badges({ badges, commentId }) {
	const getNames = theseBadges => {
		return theseBadges.map(badge => (
			<div key={badge.id}>{badge.userName}</div>
		));
	};

	const renderBadge = badgeType => {
		const theseBadges =
			badges && badges.filter(b => b.type == badgeType.key);
		return (
			<div key={badgeType.key}>
				{theseBadges.length > 0 && (
					<div className="column-spaced">
						<Tooltip
							title={getNames(theseBadges)}
							placement="bottomRight"
							key={`tip-like-${commentId}`}
							className="clickable">
							<div className={`column ${badgeType.icon}`}></div>
							<div className="column-narrow text-medium bold">
								{theseBadges.length}
							</div>
							<div className="clear" />
						</Tooltip>
					</div>
				)}
			</div>
		);
	};

	return (
		<div key={`badge-${commentId}`}>
			{Object.keys(BadgeType).map(badgeType =>
				renderBadge(BadgeType[badgeType]),
			)}
			<div className="clear" />
		</div>
	);
}
